import {Form} from 'react-bootstrap';
import {ControlledInput, RadioCheckInput} from '../../interfaces/Forms';
import CustomTooltip from '../../../Components/CustomTooltip';

interface RadioInputControlledProps {
    options: RadioCheckInput<string>[];
    description?: string;
}
const RadioInputControlled = ({
    name,
    label,
    options,
    description,
    onChange,
    onBlur,
    onReset,
    touched,
    errors,
}: ControlledInput & RadioInputControlledProps): JSX.Element => {
    return (
        <>
            <Form.Label className="fw-bold fs-3 required">
                {label}
                {description && (
                    <CustomTooltip label={description}>
                        <i className="bi bi-info-circle ms-2 text-muted" style={{cursor: 'pointer'}} />
                    </CustomTooltip>
                )}
            </Form.Label>
            <Form.Group>
                {options.map(({label, value, checked}, index) => {
                    return (
                        <Form.Check
                            id={name + '_' + value}
                            className="mb-2"
                            name={name}
                            type="radio"
                            label={
                                <span style={{color: '#686868', fontSize: '1.15rem', fontWeight: 500}}>
                                    {label}
                                </span>
                            }
                            value={value}
                            onChange={onChange}
                            onBlur={onBlur}
                            onReset={onReset}
                            defaultChecked={checked ?? false}
                            key={index}
                        />
                    );
                })}
                {touched && errors && (
                    <div className="fv-plugins-message-container">
                        <div className="fv-help-block">
                            <span role="alert">{errors}</span>
                        </div>
                    </div>
                )}
            </Form.Group>
        </>
    );
};

export default RadioInputControlled;
